<template>
  <div class="home">
    <Welcome :class="[isMobile ? 'scroll-snap-type-item' : '']" />
    <!--Карточки-->
    <v-container>
      <v-row justify="center">
        <v-col cols="10" md="3" sm="5" v-for="(card, i) in cards" :key="i"
        :class="[isMobile ? 'scroll-snap-type-item' : '']" >
          <v-card class="mx-auto card-bounce" :to="`${card.link ? card.link : ''}`" min-width="25%" >
            <v-img :aspect-ratio="3/4" class="card-style" :src="`/img/home_cards/${card.image}`">
              <v-row align="end" class="fill-height">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="card-text text-center pa-1" v-for="(title, i) in card.name" :key="i">
                      {{title}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-row>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ['isMobile'],
  components: {
    Welcome: () => import('@/components/Welcome')
  },
  data() {
    return {
      cards: [{
          name: ['Зал Славы'],
          image: 'medals.jpg',
          link: '/hall-of-glory-egp'
        },
        {
          name: ['Сила', 'Юрий Гром'],
          image: 'YuriGrom.jpg',
          link: '/power-yuri-grom'
        },
        {
          name: ['Фракция', 'EG Union'],
          image: 'faction.jpg',
          link: '/fraction-eg-union'
        },
        // {
        //   name: ['AX-Corps'],
        //   image: 'ax-corps.jpg',
        //   link: '/ax-corps'
        // }
      ]
    }
  }
}
</script>

<style scoped>
    .card-text {
      font-size: 2rem;
      font-family: "EnigmaticUnicodeRegular";
      word-break: break-word;
    }
</style>


